<div *ngIf="item && item.cells" class="grid-cell-ellipsis flex flex-row justify-between items-center">
  <span (click)="onIconClicked()" class="icon"
        [ngClass]="{isFormulaField: !!item.cells[fieldDefinition.key] && !!item.cells[fieldDefinition.key].value}">
    <i class="far fa-function fa-xm inactive" matTooltip="Set Formula Field"></i>
    <i class="fas fa-function fa-xm active" matTooltip="Formula Field"></i>
  </span>
</div>
